/* ============================================================
   Fralora — כרטיס מוצר
   assets/fralora-card.js
   בחירת נפח, עדכון מחיר ומחיר למ״ל, הוספה לסל בלי מעבר עמוד.
   אפשר להגדיר התנהגות מול מגירת הסל דרך window.FraloraCardConfig
   (ראו הוראות ההתקנה).
   ============================================================ */
(function () {
  if (window.FraloraCard) return;

  var config = Object.assign(
    {
      // מזהי סקשנים לרענון אחרי הוספה, למשל ['cart-drawer', 'cart-icon-bubble']
      sectionsToRefresh: [],
      // סלקטור לאלמנט שמציג את מספר הפריטים בסל (null = לא לעדכן)
      cartCountSelector: null,
      // סלקטור לכפתור שפותח את מגירת הסל, או פונקציה
      openCart: null,
      // פונקציה שתרוץ אחרי הוספה מוצלחת: (item, cart, response) => {}
      onAdded: null,
      labels: {
        adding: 'מוסיף…',
        added: 'נוסף לסל ✓',
        error: 'המוצר לא נוסף לסל. נסו שוב.'
      },
      addedResetMs: 2400
    },
    window.FraloraCardConfig || {}
  );
  config.labels = Object.assign(
    { adding: 'מוסיף…', added: 'נוסף לסל ✓', error: 'המוצר לא נוסף לסל. נסו שוב.' },
    (window.FraloraCardConfig && window.FraloraCardConfig.labels) || {}
  );

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- כסף ---------- */

  function withDelimiters(cents, precision, thousands, decimal) {
    var n = (cents / 100).toFixed(precision);
    var parts = n.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = (format || '{{amount}} ₪').replace(/<[^>]*>/g, '');
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    value = value.replace(/[.,]00$/, ''); // כמו money_without_trailing_zeros
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- בחירת נפח ---------- */

  function updateCard(card, input) {
    var format = card.getAttribute('data-money-format');
    var ppmMax = Number(card.getAttribute('data-ppm-max')) || 30;
    var price = Number(input.getAttribute('data-price'));
    var compare = Number(input.getAttribute('data-compare'));
    var ml = Number(input.getAttribute('data-ml'));

    var wrap = card.querySelector('[data-fc-price-wrap]');
    var nowEl = card.querySelector('[data-fc-price]');
    var wasEl = card.querySelector('[data-fc-compare]');
    var ppmEl = card.querySelector('[data-fc-ppm]');
    var saleBadge = card.querySelector('[data-fc-sale-badge]');

    var render = function () {
      if (nowEl) nowEl.textContent = formatMoney(price, format);

      var onSale = compare > price;
      if (wasEl) {
        wasEl.hidden = !onSale;
        wasEl.textContent = onSale ? formatMoney(compare, format) : '';
      }
      if (saleBadge) {
        saleBadge.hidden = !onSale;
        if (onSale) {
          var saleText = saleBadge.querySelector('[data-fc-sale-text]') || saleBadge;
          saleText.textContent = '−' + Math.floor(((compare - price) / compare) * 100) + '%';
        }
      }
      if (ppmEl) {
        var showPpm = ml > 0 && ml <= ppmMax;
        ppmEl.hidden = !showPpm;
        ppmEl.textContent = showPpm
          ? formatMoney(Math.round(price / ml), format) + ' ' + (ppmEl.getAttribute('data-suffix') || '')
          : '';
      }
      if (wrap) wrap.classList.remove('is-updating');
    };

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (wrap && !reduce) {
      wrap.classList.add('is-updating');
      window.setTimeout(render, 160);
    } else {
      render();
    }
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('.fc__size-input');
    if (!input) return;
    var card = input.closest('[data-fc]');
    if (card) updateCard(card, input);
  });

  /* ---------- הוספה לסל ---------- */

  function setButton(button, state, text) {
    var label = button.querySelector('[data-fc-add-label]') || button;
    if (!button.hasAttribute('data-default-label')) {
      button.setAttribute('data-default-label', label.textContent.trim());
    }
    if (state) button.setAttribute('data-state', state);
    else button.removeAttribute('data-state');
    label.textContent = text || button.getAttribute('data-default-label');
  }

  function renderSections(sections) {
    if (!sections) return;
    var parser = new DOMParser();
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      var target = document.getElementById('shopify-section-' + id);
      if (!html || !target) return;
      var fresh = parser.parseFromString(html, 'text/html').getElementById('shopify-section-' + id);
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (config.cartCountSelector) {
          document.querySelectorAll(config.cartCountSelector).forEach(function (el) {
            el.textContent = cart.item_count;
          });
        }
        return cart;
      })
      .catch(function () { return null; });
  }

  function openCart() {
    if (typeof config.openCart === 'function') return config.openCart();
    if (typeof config.openCart === 'string') {
      var trigger = document.querySelector(config.openCart);
      if (trigger) trigger.click();
    }
  }

  function addToCart(form, button) {
    var card = form.closest('[data-fc]');
    var msg = card && card.querySelector('[data-fc-msg]');
    var idInput = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
    if (!idInput) return;

    if (msg) msg.textContent = '';
    setButton(button, 'adding', config.labels.adding);
    button.setAttribute('aria-busy', 'true');

    var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
    if (config.sectionsToRefresh.length) {
      body.sections = config.sectionsToRefresh.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        renderSections(data.sections);
        setButton(button, 'added', config.labels.added);
        var item = data.items ? data.items[0] : data;
        return fetchCart().then(function (cart) {
          document.dispatchEvent(new CustomEvent('fralora:cart:added', { detail: { item: item, cart: cart } }));
          // המוצר כבר בסל: תקלה בקוד של התבנית לא תציג הודעת שגיאה ללקוח
          try {
            if (typeof config.onAdded === 'function') config.onAdded(item, cart, data);
            openCart();
          } catch (hookError) {
            if (window.console) console.warn('FraloraCard onAdded', hookError);
          }
        });
      })
      .catch(function (error) {
        setButton(button, null);
        if (msg) msg.textContent = (error && error.description) || config.labels.error;
      })
      .then(function () {
        button.removeAttribute('aria-busy');
        if (button.getAttribute('data-state') === 'added') {
          window.setTimeout(function () { setButton(button, null); }, config.addedResetMs);
        }
      });
  }

  // שלב capture: תופסים את הלחיצה לפני שקוד אחר של התבנית מגיש את הטופס,
  // כך שהמוצר לא נוסף פעמיים. בלי JavaScript הטופס עדיין עובד כרגיל.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('[data-fc-add]');
      if (!button) return;
      var form = button.closest('[data-fc-form]');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      if (button.getAttribute('data-state') === 'adding') return;
      addToCart(form, button);
    },
    true
  );

  window.FraloraCard = { config: config, formatMoney: formatMoney, updateCard: updateCard };
})();
